import { createReducer, on } from '@ngrx/store';

import { MsalAuthActions } from '../actions/msal-auth.actions';
import {
  AuthenticationStatus,
  initialMsalAuthState,
  MsalAuthState,
} from '../state/msal-auth.state';
import { extractParticipantIdFromToken } from '../../utils/token.utils';

export const msalAuthReducer = createReducer(
  initialMsalAuthState,
  on(
    MsalAuthActions.setAuthenticationState,
    (state, { status, accountInfo }): MsalAuthState => ({
      ...state,
      authenticationStatus: status,
      accountInfo,
      authenticatedParticipantId: extractParticipantIdFromToken(
        accountInfo?.idTokenClaims ?? null,
      ),
      error: null,
      authErrorCode: null,
    }),
  ),
  on(
    MsalAuthActions.handleAuthError,
    (state, { error }): MsalAuthState => ({
      ...state,
      authenticationStatus: AuthenticationStatus.Unauthenticated,
      error: error.message,
      authErrorCode: error.errorCode || null,
    }),
  ),
  on(
    MsalAuthActions.setErrorCode,
    (state, { errorCode }): MsalAuthState => ({
      ...state,
      error: errorCode?.toString(),
      authErrorCode: errorCode,
    }),
  ),
);
